var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BlueLink } from '@hn-ui/links';
import { Play } from '@hn-ui/icons';
import { styled } from 'styled-components';
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-1gln5j0" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var ScLink = styled(BlueLink).withConfig({ displayName: "ScLink", componentId: "sc-1ubdfyn" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: ", ";\n  gap: 0 8px;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: ", ";\n  gap: 0 8px;\n"])), function (_a) {
    var t = _a.theme;
    return t.colors.black10;
});
export var TaskCell = function (_a) {
    var original = _a.row.original, onClick = _a.onClick;
    var name = original.name, data = original.data;
    return (_jsx(ScCell, { children: _jsxs(ScLink, __assign({ href: data === null || data === void 0 ? void 0 : data.url, target: '_blank', onClick: onClick }, { children: [_jsx(Play, {}, void 0), _jsx("span", { children: name }, void 0)] }), void 0) }, void 0));
};
var templateObject_1, templateObject_2;
